export const LOG = {
  LEVEL: 1 // 0: NONE, 1: Error, 2: Warn, 3: Info, 4: Log
};
export const APPS = {
  LANGUAGE: "" // empty means use default language. English language code is en.
};
export const BACKEND = {
  BASE_URL: window.location.origin
};
